import { useState, useEffect } from 'react';
import mustache from 'mustache';

import { useCustomComponentStateContext } from './useCustomComponentState';

const useJsonApi = ({
  mlProductRecsEnabled,
}: {
  mlProductRecsEnabled: boolean | undefined;
}): unknown => {
  const { state } = useCustomComponentStateContext();
  const [rawJsonData, setJsonData] = useState<unknown>();

  const type = state?.queryData?.retailerSettings?.productRecommendations?.type;
  // mlProductRecsEnabled denotes Narvar Product Recommendations
  // If this feature flag is OFF, we need to fall back to JSON Api based recommendations.
  // api field for the type ML_ENGINE will be on jsonApi.
  const api =
    (type === 'JSON' &&
      state?.queryData?.retailerSettings?.productRecommendations?.api) ||
    (type === 'ML_ENGINE' &&
      mlProductRecsEnabled === false &&
      state?.queryData?.retailerSettings?.productRecommendations?.jsonApi) ||
    undefined;

  const { urlTemplate, method } = api ?? {};

  const body: unknown = api?.body;
  const headers: unknown = api?.headers;

  const { pageContext } = state || {};

  useEffect(() => {
    if (typeof urlTemplate !== 'string') return;
    const jsonApiUrl = mustache.render(urlTemplate, pageContext);
    const jsonApiBody = body
      ? mustache.render(JSON.stringify(body), pageContext)
      : null;

    // eslint-disable-next-line no-void
    void (async () => {
      try {
        const response = await fetch(jsonApiUrl, {
          method,
          body: jsonApiBody,
          headers:
            headers && typeof headers === 'object'
              ? { ...headers }
              : { 'content-type': 'application/json' },
        });

        const apiResults: unknown = await response.json();
        setJsonData(apiResults);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    })();
  }, [urlTemplate, method, body, headers, pageContext]);

  return rawJsonData;
};

export default useJsonApi;
